import PropTypes from 'prop-types';
import PlanningTopicsInfoProps from '../../types/components/PlanningTopicsInfoProps';
import './PlanningTopicsInfo.scss';

const PlanningTopicsInfo = (props: PlanningTopicsInfoProps) => {
  const {
    topicTitle,
    topicTitleId,
    color
  } = props;

  return (

    <div className="card" data-testid={`planningTopicsInfoCard-${topicTitleId}`}>
        <span className="card-header" style={{ backgroundColor: color }}
              data-testid="planningTopicsInfoHeader" />
      <div className="card-text">
        {topicTitle}
      </div>
    </div>
  )
}

PlanningTopicsInfo.propTypes = {
  topicTitle: PropTypes.string.isRequired,
  topicTitleId: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
}

export default PlanningTopicsInfo;